export default {"src":"/_next/static/media/logo.59f661cc.svg","height":72,"width":259,"blurWidth":0,"blurHeight":0};